import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatarTempo } from "../../../utils";
import { Button, Card, Spinner, Dropdown } from "flowbite-react";
import { HiLockClosed } from "react-icons/hi";
import VisitantesUnicos from "./Cards/VisitantesUnicos";
import TempoMedio from "./Cards/TempoMedio";
import MediaFotos from "./Cards/MediaFotos";
import MediaScrolls from "./Cards/MediaScrolls";
import Convercoes from "./Cards/Convercoes";
import CliquesLinks from "./Cards/CliquesLinks";
import RetornoVisitantes from "./Cards/RetornoVisitantes";
import Dispositivos from "./Cards/Dispositivos";
import TotalVisitas from "./Cards/TotalVisitas";
import Referrers from "./Cards/Referrers";
import RankProdutos from "./Cards/RankProdutos";
import { getVisitasAction, getAcoesAction } from "../../../actions/user";
import { loadProdutos } from "../../../actions/produto";
import RankTags from "./Cards/RankTags";
import TermosBusca from "./Cards/TermosBusca";
import HorarioMaisAtivo from "./Cards/HorarioMaisAtivo";
import TendenciaSemanal from "./Cards/TendenciaSemanal";

const periodos = [
  { label: "Ultimas 24h", value: "24h" },
  { label: "Ultimos 7 dias", value: "7d" },
  { label: "Ultimos 30 dias", value: "30d" },
  { label: "Ultimos 12 meses", value: "12m" },
  { label: "Desde o inicio", value: "all" },
];

const LEGACY_ACTION_TO_LINK_TYPE = {
  clicar_whatsapp: "whatsapp",
  clicar_instagram: "instagram",
  clicar_facebook: "facebook",
  clicar_tiktok: "tiktok",
  clicar_twitter: "twitter_x",
  clicar_geolocalizacao: "geolocalizacao",
};

const LINK_TYPE_LABEL = {
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  twitter_x: "X",
  geolocalizacao: "Localizacao",
  endereco: "Endereco",
  telefone: "Telefone",
};

const Analise = () => {
  const dispatch = useDispatch();
  const { visitas, acoes, loadingVisitas, loadingAcoes } = useSelector(
    (state) => state.analytics
  );
  const { loja, profile } = useSelector((state) => state.user);
  const [filtroTempo, setFiltroTempo] = useState("7d");
  const [mostrarMais, setMostrarMais] = useState(false);
  const acessoAnalise = profile?.permissoesPlano?.acessoAnaliseEngajamento !== false;

  useEffect(() => {
    if (!acessoAnalise) return;
    dispatch(getVisitasAction());
    dispatch(getAcoesAction());
  }, [acessoAnalise, dispatch]);

  useEffect(() => {
    if (loja?.id) {
      dispatch(loadProdutos(loja.id));
    }
  }, [dispatch, loja?.id]);

  if (!acessoAnalise) {
    return (
      <div>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mt-8 lg:mt-2 mb-4 select-none cursor-default">
          Analise de Engajamento
        </h2>
        <Card className="border border-gray-200 bg-white">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
              <HiLockClosed className="w-6 h-6 text-gray-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900">
                Faca upgrade do seu plano para ter acesso a esse recurso
              </h3>
              <p className="text-sm text-gray-600">
                A analise de engajamento esta disponivel nos planos pagos.
              </p>
            </div>
            <Button
              gradientDuoTone="purpleToPink"
              onClick={() => {
                window.location.href = "/app/planos";
              }}
            >
              Ver planos
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  if (loadingVisitas || loadingAcoes || !visitas || !acoes) {
    return (
      <div className="flex justify-center items-center min-h-[300px]">
        <Spinner aria-label="Carregando informacoes das visitas" size="xl" />
      </div>
    );
  }

  const agora = new Date();
  const filtrarPorTempo = (lista, tipo) => {
    const limite = new Date();
    switch (tipo) {
      case "24h":
        limite.setHours(agora.getHours() - 24);
        break;
      case "7d":
        limite.setDate(agora.getDate() - 7);
        break;
      case "30d":
        limite.setDate(agora.getDate() - 30);
        break;
      case "12m":
        limite.setFullYear(agora.getFullYear() - 1);
        break;
      default:
        return lista;
    }
    return lista?.filter((item) => new Date(item.createdAt) >= limite);
  };

  const visitasFiltradas = filtrarPorTempo(visitas, filtroTempo);
  const acoesFiltradas = filtrarPorTempo(acoes, filtroTempo);

  const mapaCliques = {};
  (acoesFiltradas || []).forEach((acao) => {
    if (!String(acao?.tipo_acao || "").startsWith("clicar_")) return;

    const tipo =
      acao.link_tipo || LEGACY_ACTION_TO_LINK_TYPE[acao.tipo_acao] || "outro";
    const label = acao.link_label || LINK_TYPE_LABEL[tipo] || tipo;
    const key = `${tipo}::${label}`;

    if (!mapaCliques[key]) {
      mapaCliques[key] = {
        tipo: label,
        categoria: tipo,
        total: 0,
      };
    }
    mapaCliques[key].total += 1;
  });

  const linksComCliques = Object.values(mapaCliques)
    .filter((link) => link.total > 0)
    .sort((a, b) => b.total - a.total);

  const visitantesUnicos = [
    ...new Set(visitasFiltradas?.map((v) => v.session_id)),
  ].length;

  const sessionsComConversao = new Set(
    acoesFiltradas
      ?.filter((a) => {
        const tipo =
          a.link_tipo || LEGACY_ACTION_TO_LINK_TYPE[a.tipo_acao] || null;
        return tipo === "whatsapp" || tipo === "geolocalizacao" || tipo === "endereco";
      })
      ?.map((a) => a.session_id)
  );

  const totalConversoesUnicas = sessionsComConversao.size;
  const taxaConversao =
    visitantesUnicos > 0 ? (totalConversoesUnicas / visitantesUnicos) * 100 : 0;

  const mapaSessoes = {};
  visitasFiltradas?.forEach((visita) => {
    const session = visita.session_id;
    mapaSessoes[session] = (mapaSessoes[session] || 0) + 1;
  });

  const totalRetornaram = Object.values(mapaSessoes)?.filter((qtd) => qtd > 1).length;
  const percentualRetorno =
    visitantesUnicos > 0 ? (totalRetornaram / visitantesUnicos) * 100 : 0;

  const dispositivos = [
    {
      tipo: "Desktop",
      total: visitasFiltradas?.filter((v) => v.device === "desktop").length,
    },
    {
      tipo: "Mobile",
      total: visitasFiltradas?.filter((v) => v.device === "mobile").length,
    },
  ];

  const normalizarReferrer = (url) => {
    if (!url || url === "direto") return "Acesso Direto";
    const u = url.toLowerCase();
    if (u.includes("instagram")) return "Instagram";
    if (u.includes("whatsapp") || u.includes("wa.me")) return "WhatsApp";
    if (u.includes("google")) return "Google";
    if (u.includes("facebook")) return "Facebook";
    try {
      return new URL(url).hostname.replace("www.", "");
    } catch {
      return url;
    }
  };

  const contagemReferrers = {};
  visitasFiltradas?.forEach((v) => {
    const origem = normalizarReferrer(v.referrer);
    contagemReferrers[origem] = (contagemReferrers[origem] || 0) + 1;
  });

  const referrers = Object.entries(contagemReferrers)?.map(([nome, total]) => ({
    origem: nome,
    total,
  }));

  return (
    <div>
      <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mt-8 lg:mt-2 mb-4 select-none cursor-default">
        Analise de Engajamento
      </h2>

      <div className="mb-4">
        <Dropdown
          label={`Periodo: ${periodos.find((p) => p.value === filtroTempo).label}`}
          dismissOnClick={true}
        >
          {periodos?.map((p) => (
            <Dropdown.Item key={p.value} onClick={() => setFiltroTempo(p.value)}>
              {p.label}
            </Dropdown.Item>
          ))}
        </Dropdown>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
        <VisitantesUnicos visitas={[...new Set(visitasFiltradas?.map((v) => v.session_id))].length} />
        <TotalVisitas visitas={visitasFiltradas?.length} />
        <TempoMedio
          tempo={formatarTempo(
            visitasFiltradas?.reduce((acc, cur) => acc + cur.duracao_ms, 0) /
              visitasFiltradas?.length
          )}
        />
        <MediaFotos
          visualizacoes={(
            visitasFiltradas?.reduce((acc, cur) => acc + cur.fotos_carregadas, 0) /
            visitasFiltradas.length
          ).toFixed(1)}
        />
        <MediaScrolls
          scrolls={(
            visitasFiltradas?.reduce((acc, cur) => acc + cur.scrolls, 0) /
            visitasFiltradas?.length
          ).toFixed(1)}
        />
        <RetornoVisitantes percentual={percentualRetorno.toFixed(1)} />
      </div>

      <div className="flex justify-center mb-6">
        <button
          onClick={() => setMostrarMais(!mostrarMais)}
          className="flex items-center gap-2 text-sm text-emerald-600 hover:underline focus:outline-none"
        >
          {mostrarMais ? "Ocultar estatisticas" : "Mais estatisticas"}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-4 w-4 transition-transform ${
              mostrarMais ? "rotate-180" : "rotate-0"
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>

      {mostrarMais && (
        <>
          <CliquesLinks cliques={linksComCliques} />
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
            <Dispositivos dispositivos={dispositivos} />
            <Convercoes convercoes={totalConversoesUnicas} taxa={taxaConversao.toFixed(1)} />
            <RankTags acoes={acoesFiltradas} />
            <TermosBusca acoes={acoesFiltradas} />
          </div>
          <HorarioMaisAtivo visitas={visitasFiltradas} />
          <TendenciaSemanal visitas={visitas} />
          <Referrers referrer={referrers} />
          <RankProdutos acoes={acoesFiltradas} />
        </>
      )}
    </div>
  );
};

export default Analise;
